.container {
  padding-bottom: 90px;
}

.image {
  object-fit: cover;
  width: 100%;
  height: 320px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.3);
}

.defaultImage {
  object-fit: contain;
  height: 200px;
}

.form {
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
}

.error {
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(255, 60, 60, 0.14);
  border: 1px solid rgba(255, 60, 60, 0.4);
}

.bookButton {
  width: 100%;
  margin-top: 8px;
}

.modeSelector {
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
}

.modeOption {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 10px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.06);
  text-align: center;
}

.modeOptionActive {
  border-color: rgba(255, 255, 255, 0.85);
  background: rgba(255, 255, 255, 0.14);
}

/* Dimmed by colour, not by `opacity`: a translucent option faded the SOON badge with it to
   1.36:1 (BUG-18). The label uses the secondary text token; the badge is accent ink on accent. */
.modeOptionDisabled {
  border-color: var(--gac-line-divider);
  background: var(--gac-surface-raised);
  cursor: not-allowed;
  pointer-events: none;
}

.soonBadge {
  padding: 1px 6px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.4px;
  background: var(--gac-accent);
  color: var(--gac-accent-ink);
}

.modeCaption {
  padding: 0 2px;
}

/* Takes the place of the booking form when the registry says this buyer cannot book here (app#176). */
.notice {
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  background: rgba(255, 170, 0, 0.12);
  border: 1px solid rgba(255, 170, 0, 0.35);
}
